import axios from "axios";
import { get } from "lodash";
import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  REQUEST_MASTER_ADDDISH,
  REQUEST_CREATE_MASTER_ADDDISH,
  SET_MASTER_ADDDISH,
  SUCCESS_CREATE_MASTER_ADDDISH,
  ERROR_GET_MASTER_ADDDISH,
  ERROR_CREATE_MASTER_ADDDISH,
  SUCCESS_DELETE_MASTER_ADDDISH,
  SUCCESS_UPDATE_MASTER_ADDDISH,
  REQUEST_DELETE_MASTER_ADDDISH,
  REQUEST_UPDATE_MASTER_ADDDISH,
  ERROR_DELETE_MASTER_ADDDISH,
  ERROR_UPDATE_MASTER_ADDDISH,
} from "./adddishActionTypes";

function* requestMasterAdddish(action: Record<string, any>): any {
  try {
    const result: any = yield call(getAdddishMaster);
    yield put({ type: SET_MASTER_ADDDISH, payload: result.data.data });
  } catch (error: any) {
    console.log(error);
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = error.response.data.message || "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_GET_MASTER_ADDDISH, payload: message });
  }
}

function* requestUpdateMasterTagAdddish(action: Record<string, any>): any {
  try {
    const result = yield call(
      updateMasterAdddish,
      action.data.payload,
      action.data._id
    );
    yield put({
      type: SUCCESS_UPDATE_MASTER_ADDDISH,
      payload: result.data.data,
    });
    if (action.onSuccess) action.onSuccess(result);
  } catch (error: any) {
    console.log(error);
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = error.response.data.message || "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_UPDATE_MASTER_ADDDISH, payload: message });
  }
}

function* requestDeleteMasterTagAdddish(action: Record<string, any>): any {
  try {
    yield call(deleteMasterAdddish, get(action, "payload._id", ""));
    yield put({
      type: SUCCESS_DELETE_MASTER_ADDDISH,
      payload: get(action, "payload._id", ""),
    });
  } catch (error: any) {
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_DELETE_MASTER_ADDDISH, payload: message });
  }
}

function* requestCreateMasterAdddish(action: Record<string, any>): any {
  try {
    const result = yield call(createMasterAdddish, action.payload);

    yield put({
      type: SUCCESS_CREATE_MASTER_ADDDISH,
      payload: result.data.data,
    });
    if (action.onSuccess) action.onSuccess(result);
    // update relevant category as well
  } catch (error: any) {
    console.log(error);
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = error.response.data.message || "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_CREATE_MASTER_ADDDISH, payload: message });
  }
}

export function getAdddishMaster() {
  return axios({
    method: "GET",
    url: `${process.env.REACT_APP_BASE_URL}/admin/dishes-category`,
    withCredentials: true,
  });
}

export function createMasterAdddish(payload: Record<string, any>) {
  return axios({
    method: "post",
    url: `${process.env.REACT_APP_BASE_URL}/admin/dishes-category`,
    data: payload,
    withCredentials: true,
  });
}

export function deleteMasterAdddish(_id: string) {
  return axios({
    method: "delete",
    url: `${process.env.REACT_APP_BASE_URL}/admin/dishes-category/${_id}`,
    withCredentials: true,
  });
}
export function updateMasterAdddish(payload: Record<string, any>, _id: string) {
  return axios({
    method: "patch",
    url: `${process.env.REACT_APP_BASE_URL}/admin/dishes-category/${_id}`,
    data: payload,
    withCredentials: true,
  });
}

const adddishMasterSaga = function* () {
  yield all([
    takeLatest(REQUEST_MASTER_ADDDISH, requestMasterAdddish),
    takeLatest(REQUEST_CREATE_MASTER_ADDDISH, requestCreateMasterAdddish),
    takeLatest(REQUEST_UPDATE_MASTER_ADDDISH, requestUpdateMasterTagAdddish),
    takeLatest(REQUEST_DELETE_MASTER_ADDDISH, requestDeleteMasterTagAdddish),
  ]);
};

export default adddishMasterSaga;
